// test1624
(1624 && 0);
